/* eslint-disable react-hooks/exhaustive-deps */
import LoadingContent from 'components/LoadingContent';
import { useFormik } from 'formik';
import React, { useEffect } from 'react';
import TopProcessBar from 'screen/selectCollege/TopProcessBar';
import { Container, Form, Spinner, Button } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { useHistory, useLocation } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import SearchIcon from '@mui/icons-material/Search';
import {
  BoolToString,
  checkEnableParseJSON,
  formatBoolean,
  reorder,
} from 'components/helper/helper';
import { getIBSubjectTest, updateIBSubjectTest } from 'app/testingSlice/testingSlice';
import IBSubjectConfig from './components/IBSubjectConfig';
import { debounce } from 'lodash';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import CheckboxInput from 'components/input/CheckboxInput';
import { ExpandMore } from 'screen/activitiesAndHonors/Activities';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import Grid from '@mui/joy/Grid';
import moment from 'moment';
import pageStatusService from 'services/pageStatusService';
import { PAGE_NAME } from 'constants/common';
import { toggleReviewedAndComplete } from 'services/reviewAndComplete';
import { ModalCheckTestFields } from '../common/ModalCheckTestFields';
import { scrollToObject, scrollToCenterObject } from 'components/helper/ui_helper';
import { getAccessToken, getUserId, removeAccessToken, removeUserId } from 'utils/sessionStorage';
//import Cookies from 'js-cookie';
//import { authenticateSettings } from 'components/helper/appConfig';



type Props = {};

const IBSubjectTest = (props: Props) => {
  const MAX_IB_TESTS = 20;
  const [loading, setLoading] = React.useState(false);
  const [adding, setAdding] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  const testing:any = useAppSelector((store:any) => store.testing);
  const dispatch:any = useAppDispatch();
  const history:any = useHistory();
  const location:any = useLocation();
  let studentId = getUserId();
  let token = getAccessToken();
  const query = new URLSearchParams(useLocation().search);
  // const indexExpanded = query.get('index');
  const [expandAll, setExpandAll] = React.useState(false);
  const [expandActive, setExpandActive] = React.useState<number>(0);
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const onReviewdAndComplete = () => {
    void toggleReviewedAndComplete(PAGE_NAME.IB_SUBJECT_TEST, reviewedAndComplete, setReviewedAndComplete);
  }
  let checkIndex = query.get('index');
  const [check, setCheck] = React.useState(query.get('check'));
  const [showModal, setShowModal] = React.useState(false);
  const [testData, setTestData] = React.useState<any>(null);

  const formik = useFormik({
    initialValues: {
      is_have_ib_exam_report: '',
      ib_test_array: [], // Only use actual data from API
      is_completed_full_ib: false,
    },
    onSubmit: async (values) => {
      studentId = getUserId();
      token = getAccessToken();
      if (token && studentId) {
        try {
          let isValid = true;
          if (values.ib_test_array && values.ib_test_array.length>0) {
            for (let i=0; i< values.ib_test_array.length; i++) {
              let testItem:any = values.ib_test_array[i];
              let dateTaken = testItem?.dateTaken;
              if (!dateTaken) {
                isValid = false;
                expandFold(i+1, values.ib_test_array.length);
                break;
              }
              let dateTakenMonth = moment(dateTaken).format('MMMM');
              let dateTakenYear = moment(dateTaken).format('yyyy');

              if (dateTakenMonth === 'Invalid date') {
                isValid = false;
                expandFold(i+1, values.ib_test_array.length);
                break;
              }

              if (Number(dateTakenYear)<2000) {
                isValid = false;
                expandFold(i+1, values.ib_test_array.length);
                break;
              }

            }
          }

          console.log('isValid:', isValid);
          if (isValid) {
            const newValues = {
              ...values,
              student_id: studentId,
              is_have_ib_exam_report: formatBoolean(values.is_have_ib_exam_report),
              ib_test_array: JSON.stringify(values.ib_test_array),
              // Remove number_of_ib_test_report dependency - let API handle the count
            };
            await dispatch(updateIBSubjectTest(newValues)).unwrap();         
          }
          else {
            if (adding) {
              setAdding(false);
            }
            else {
              setTimeout(function(){
                let btns:any = document.querySelectorAll('.btn-save-info');
                for(let j=0; j<btns.length; j++) {
                  btns[j].click();
                }
              },500);
            }
          }

        } catch (ex) {
          console.log('Error: ', ex);
        }
      } else {
        handleLogout();
      }
    },
  });

  const handleExpandAll = () => {
    if (!check) {
      setExpandAll(!expandAll);
      if (!expandAll) {
        setExpandActive(formik.values.ib_test_array.length);
      } else {
        setExpandActive(0);
      }
    } else {
      setExpandAll(!expandAll);
    }
  };

  useEffect(() => {
    // if (expandActive === formik.values.ib_test_array.length) {
    //   setExpandAll(true);
    // }

    if (expandActive === 0) {
      setExpandAll(false);
    }
  }, [expandActive, formik.values.ib_test_array.length]);


  const AutoScrollAndExpand = () => {
    try {
      const hash = location.hash.slice(1); // Remove the '#' character from the hash
      //console.log('hash:', hash);

      //#region scroll to and expand fold
      checkIndex = query.get('index');
      if (checkIndex) {
        setTimeout(() => {
          scrollToObject(`fold_${checkIndex}`, 200);
        }, 500);

        if (formik.values.ib_test_array && formik.values.ib_test_array.length>0) {
          expandFold(Number(checkIndex), formik.values.ib_test_array.length);
        }
      }     
      //#endregion
  
      if (hash && (
          hash.includes('examStatus') ||
          hash.includes('isReceivedScore') ||
          hash.includes('subject') ||
          hash.includes('level') ||
          hash.includes('language') ||
          hash.includes('ibExamSubjectNameDescribeOther') ||
          hash.includes('dateTaken') ||
          hash.includes('score'))) 
      {
          setTimeout(() => {
            scrollToCenterObject(hash);
          }, 800);
      }
    }
    catch(ex){
      console.log('Error:', ex);
    }
  }

  useEffect(() => {
    AutoScrollAndExpand();
  }, [location]);

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const handleContinue = () => {
    formik.handleSubmit();
    const nextRoute = Object.keys(testing.roleTest).find(
      (key, index) =>
        index > Object.keys(testing.roleTest).indexOf('ibSubjectTest') &&
        testing.roleTest[key] === true
    );
    history.push(nextRoute ? routers?.[nextRoute]?.path : routers.activities.path);
  };

  const getDetail = async () => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      setLoading(true);
      try {
        const pageStatus: {
          student_completed: boolean;
        } = await pageStatusService.getPageStatusByPageName(studentId, PAGE_NAME.IB_SUBJECT_TEST);
        if(pageStatus) {
          setReviewedAndComplete(pageStatus.student_completed);
        }
        let res = await dispatch(getIBSubjectTest(studentId)).unwrap();
        const dataLoaded: any = res;
        if (dataLoaded) {
          // Only use actual data from API, ignore number_of_ib_test_report dependency
          const actualIbTestArray = checkEnableParseJSON(dataLoaded.ib_test_array) ?? [];
          
          const values: any = {
            ...dataLoaded,
            ib_test_array: actualIbTestArray,
            is_have_ib_exam_report: BoolToString(dataLoaded.is_have_ib_exam_report),
          };

          formik.resetForm({ values });
          setTestData(values);
        }
        setLoading(false);
        formik.setStatus('idle');
      } catch (ex) {
        console.log('Error: ', ex);
      }
      setLoading(false);
    } else {
      handleLogout();
    }
  };

  React.useEffect(() => {
    getDetail();
  }, []);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Removed dependency on number_of_ib_test_report - only use data from API

  const expandFold = (num:number, len:number) => {
    let id= `#btn_fold_${num}_${len}[aria-expanded="false"]`;
    let dv:any = document.querySelector(id);
    if (dv) dv.click();
  }

  //#region Auto save function ==========
  React.useEffect(() => {
    if (formik.dirty) {
       debounceSaving();
       setTestData(formik.values);
    }
  }, [formik.values]);
  const debounceSaving = React.useCallback(
    debounce(() => {
      if (!loading) formik.handleSubmit();
    }, 1500),
    []
  );
  //#endregion ==========================

  const handleAddIB = () => {
    if (formik.values.ib_test_array.length > 19) return;
    setAdding(true);
    let arr:any[] = [...formik.values.ib_test_array, {}]
    formik.setFieldValue('ib_test_array', arr );

    setExpandAll(false);
    setExpandActive(arr.length-1);
    setTimeout(function() {
      expandFold(arr.length, arr.length);
    },500);
  };

  const [forceRenderKey, setForceRenderKey] = React.useState(0);

  const onDragEnd = async (result: any) => {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }
    const dataList = reorder(
      formik.values.ib_test_array,
      result.source.index, 
      result.destination.index)
    ;
    formik.setFieldValue('ib_test_array', [...dataList]);
    setForceRenderKey(forceRenderKey + 1);
  };

  // ACTData now only contains actual data from API, no auto-generated empty items
  //const ACTData: any[] = formik.values.ib_test_array ?? [];

  const handleExpandActive = (value: any) => {
    value
      ? setExpandActive(Math.abs(expandActive - 1))
      : setExpandActive(Math.abs(expandActive + 1));
  };


  const handleCheckMissing = () => {
    setCheck('1');
    setTestData(formik.values);
    setShowModal(true);
  }

  const handleCloseModal = () => {
    setShowModal(false);
    setTimeout(()=> {
      AutoScrollAndExpand();
    }, 1000);
  }


  return loading ? (
    <LoadingContent />
  ) : (
    <>
      <TopProcessBar
        stepProcess={[
          { percentOnProcess: 25, title: 'IB Tests', specialId: 'ibTests' },
          { percentOnProcess: 100, title: 'IB Scores', specialId: 'ibScores' },
        ]}
        title="Standardized Testing"
        process={1}
        icon={<CalculateOutlinedIcon />}
        isMobile={isMobile}
      />

      <Container 
        className={`main-container gm-basic-info-page ${isMobile ? 'p-mobile-2' : ''}`}
        style={{
          paddingLeft: isMobile ? '12px' : undefined,
          paddingRight: isMobile ? '12px' : undefined,
          paddingTop: isMobile ? '120px' : undefined,
          maxWidth: '100vw',
          overflow: 'hidden'
        }}
      >
        <div className={`gm-section-card ${isMobile ? 'p-mobile-2' : 'px-4 py-4'}`}>
          <Form
            style={{ 
              maxWidth: isMobile ? '100%' : '900px',
              width: '100%'
            }}
            onSubmit={formik.handleSubmit}
            className="gm-form-grid"
          >
            <div className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
              <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                IB Subject Tests
              </span>
            </div>
            <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
              <Grid xs={12} id="ibTests">
                <div className="my-2">Let's organize all your IB Subject test information!</div>
              </Grid>

              <Grid xs={12}>
                <CheckboxInput
                  disabled={reviewedAndComplete}
                  label="Check if you have completed or plan to complete the full IB diploma"
                  values={formik.values.is_completed_full_ib}
                  name="is_completed_full_ib"
                  onChange={formik.handleChange}
                />
              </Grid>
            
              {formik.values.ib_test_array.length > 0 && (
                <Grid xs={12}>
                  <div className="d-flex justify-content-end">
                    <ExpandMore
                      aria-expanded={expandAll}
                      aria-label="show all"
                      onClick={handleExpandAll}
                    >
                      {!expandAll ? <KeyboardDoubleArrowDownIcon /> : <KeyboardDoubleArrowUpIcon />}
                    </ExpandMore>
                  </div>
                </Grid>
              )}

              <Grid xs={12} id="ibScores">
                <DragDropContext onDragEnd={onDragEnd} key={forceRenderKey}>
                  <Droppable droppableId="list">
                    {(provided) => (
                      <div className='w-100 bg-white py-2 box-collapse rounded-3' ref={provided.innerRef} {...provided.droppableProps} style={{
                        paddingRight: isMobile ? "10px" : "30px",
                        paddingLeft: "10px"
                      }}>
                        {formik.values.ib_test_array.map((item:any, index:number) => (
                          <div key={index + '-' + formik.values.ib_test_array.length}>
                            <Draggable draggableId={index + '-' + formik.values.ib_test_array.length} index={index} isDragDisabled={isMobile}>
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...(isMobile ? {} : provided.dragHandleProps)}
                                >
                                  <div
                                    key={index + '-' + formik.values.ib_test_array.length}
                                    id={`fold_${index+1}_${formik.values.ib_test_array.length}`}
                                    className="position-relative"
                                  >
                                    <IBSubjectConfig
                                      disabled={reviewedAndComplete}
                                      key={index}
                                      handleSave={(values:any) => {
                                        const newACTData:any[] = [...formik.values.ib_test_array];
                                        newACTData.splice(index, 1, values);
                                        formik.setFieldValue('ib_test_array', newACTData);
                                      }}
                                      item={item}
                                      index={index}
                                      indexText={index + 1 + '/' + formik.values.ib_test_array.length}
                                      check={check}
                                      indexExpanded={checkIndex + `/` + formik.values.ib_test_array.length}
                                      expandAll={expandAll}
                                      handleExpandActive={handleExpandActive}
                                      isMobile={isMobile}
                                    />
                                    <RemoveCircleOutlineIcon
                                      className="position-absolute text-field-light pointer"
                                      style={{ 
                                        right: isMobile ? '-20px' : '-24px', 
                                        top: '12px',
                                        fontSize: isMobile ? '18px' : '24px',
                                        opacity: reviewedAndComplete ? 0.5 : 1,
                                        cursor: reviewedAndComplete ? 'not-allowed' : 'pointer'
                                      }}
                                      onClick={() => {
                                        if (reviewedAndComplete) return;
                                        const newACTData = [...formik.values.ib_test_array];
                                        newACTData.splice(index, 1);
                                        formik.setFieldValue('ib_test_array', newACTData);
                                      }}
                                    />
                                  </div>
                                </div>
                              )}
                            </Draggable>
                          </div>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </Grid>
              
              <Grid xs={12}>
                <div className="my-3 w-100 d-flex flex-column align-items-center">
                  <div className="text-field-light sized70">{`You can add up to ${MAX_IB_TESTS} IB Tests`}</div>
                  <Button variant="primary" className="p-2 px-5" onClick={handleAddIB} disabled={reviewedAndComplete}>
                    Add IB Test
                  </Button>
                </div>
              </Grid>
            </Grid>

            <div className="row my-3 pt-3 mt-4 border-top">
              <div className="col-md-6">
                <div className="text-left pt-3">
                  <div className="gm-btn-checkmissing"
                    onClick={() => handleCheckMissing()}
                  >
                    <SearchIcon/><span>Check missing values</span>
                  </div>
                  <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                    <input
                      type="checkbox"
                      style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid #6c757d',
                        borderRadius: '2px',
                      }}  
                      checked={reviewedAndComplete}
                      onClick={onReviewdAndComplete}
                    />
                    <span
                      style={{
                        fontSize: isMobile ? '14px' : '12px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      Reviewed
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="text-start text-md-end">
                <Button 
                    variant="primary" 
                    type="submit" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5 mx-2'} gm-btn-save`}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    {testing.status === 'loading' ? (
                      <Spinner size="sm" animation="border" variant="light" />
                    ) : (
                      'Save'
                    )}
                  </Button>
                  <Button 
                    variant="primary" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} gm-btn-continue`}
                    onClick={() => handleContinue()}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        <ModalCheckTestFields
          show={showModal}
          onClose={handleCloseModal}
          data={testData}
          page="ib-subject-test"
        /></div>

      </Container>
    </>
  );
};

export default IBSubjectTest;
